<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
        }
    },
    
    methods:{

    },

    mounted(){

    },
    watch: {
        async "single_object.cost_center_id"(val) {
            if (val) {
                let http_request = {
                    request_id: val,
                    department_request: true,
                };
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                if(response.status) {
                    if (response.data.departments.length) {
                        this.array_options.cost_center_department_id = response.data.departments;

                        let states_object = this.array_options.cost_center_department_id.find((key)=>{
                            return key.id === this.single_object.cost_center_department_id 
                        })

                        states_object === undefined ? 
                            this.single_object.cost_center_department_id = this.array_options.cost_center_department_id[0].id :
                            this.single_object.cost_center_department_id = states_object.id;
                        
                    } else {
                        this.array_options.cost_center_department_id = [];
                        this.single_object.cost_center_department_id = "";
                    }

                } else {
                    this.error_handling(response)
                }

            }
      },
    }
}
</script>